import { useState } from 'react';
import { Box } from '@mui/material';
import { PostedJobManagementServices } from 'admin/services';
import { useAlert } from 'common/hooks';
import { IJobPost } from 'common/models';
import { AlertDialog, Button } from 'design-library';
import { JobTypeEnum } from 'common/enums';

const PostedJobActions = ({ jobPost }: { jobPost: IJobPost }) => {
  const { onAlert } = useAlert();
  const [
    showMarkCompleteConfirmationModal,
    setShowMarkCompleteConfirmationModal,
  ] = useState(false);
  const [showDeleteConfirmationModal, setShowDeleteConfirmationModal] =
    useState(false);

  const shouldShowCompleteButton = jobPost.jobType === JobTypeEnum.FullTime;

  return (
    <Box
      display="flex"
      gap={2}
      justifyContent="center"
      alignItems="center"
      overflow="auto"
      px={4}
      width="350px"
    >
      {shouldShowCompleteButton && (
        <Button
          size="small"
          color="success"
          variant="contained"
          onClick={() => setShowMarkCompleteConfirmationModal(true)}
        >
          Mark Complete
        </Button>
      )}

      <Button
        size="small"
        color="error"
        variant="outlined"
        onClick={() => setShowDeleteConfirmationModal(true)}
      >
        Delete
      </Button>

      {showMarkCompleteConfirmationModal && (
        <AlertDialog
          open={showMarkCompleteConfirmationModal}
          title="Mark Complete Full-Time Job Post"
          onClose={() => setShowMarkCompleteConfirmationModal(false)}
          onConfirm={() => {
            PostedJobManagementServices.markCompleteFullTimeJobPost(jobPost.id)
              .catch(() =>
                onAlert('Failed to mark complete full time job post', 'error')
              )
              .finally(() => setShowMarkCompleteConfirmationModal(false));
          }}
        />
      )}

      {showDeleteConfirmationModal && (
        <AlertDialog
          open={showDeleteConfirmationModal}
          title="Delete Job Post"
          onClose={() => setShowDeleteConfirmationModal(false)}
          onConfirm={() => {
            PostedJobManagementServices.deleteJobPost(jobPost.id)
              .catch((err) =>
                onAlert(err?.message || 'Failed to delete job post', 'error')
              )
              .finally(() => setShowDeleteConfirmationModal(false));
          }}
        />
      )}
    </Box>
  );
};

export default PostedJobActions;
